module.exports = __webpack_public_path__ + "img/example2-icon.873a734e.png";